// @ts-check
import { createRouter, createWebHashHistory } from 'vue-router'
import BasicForm from './components/Basic/Form/BasicForm.vue'
import UniversityForm from './components/University/Form/UniversityForm.vue'

export const build = () => {
  const routes = [
    {
      path: '/basic',
      name: 'basic',
      component: BasicForm,
      props: true,
    },
    {
      path: '/university',
      name: 'university',
      component: UniversityForm,
      props: true,
    },
  ]
  const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scrollBehavior(to, from, savedPosition) {
      return { top: 0 }
    },
  })

  return {
    router: router,
  }
}
